export const ACTIONS = {
  ADD_EXERCISE: 'addExercise',
  REMOVE_EXERCISE: 'removeExercise',
  SET_ACTIVE_PAUSE: 'setActivePause',
};
